import React, { Component } from 'react';
import './FooterLinks.css';

import FooterLink from './FooterLink';

export class FooterLinks extends Component {
  state = {
    showContent: false,
  };

  toggleContent = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({ showContent: !prevState.showContent }));
  };

  render() {
    const {
      title = '',
      items = [],
      className = '',
      columns = '2',
      hideLinkText = false,
      inlineLinks = false,
    } = this.props;
    const { showContent } = this.state;
    const footerToggleList = showContent ? 'showFooterLinks' : '';
    const inlineLinksClassName = inlineLinks ? 'inlineFooterLinks' : '';
    const footerToggleIcon = showContent ? 'rotatePlus' : '';

    return (
      <div className={`footerLinksWrapper ${className}`}>
        {title && (
          <div className="footerTitle">
            {title}
            <span className={`footerToggle ${footerToggleIcon}`} role="button" onClick={this.toggleContent}>
              +
            </span>
          </div>
        )}
        <ul className={`footerLinks has-${columns}-columns ${footerToggleList} ${inlineLinksClassName}`}>
          {items.map((item, index) => (
            <FooterLink key={index} {...item} hideLinkText={hideLinkText} />
          ))}
        </ul>
      </div>
    );
  }
}
